import { Button } from '@/components/ui/button'
import { openCheckout } from '@/hooks/useBilling'
import { CheckCircle2 } from 'lucide-react'

interface UpgradePageProps {
  orgId: string
  orgSlug: string
}

const FEATURES = [
  'Unlimited products',
  'Unlimited team members',
  'Document exports (Word / PDF)',
  'Custom sub-requirement types',
  'Full trace matrix & DFMEA',
]

export function UpgradePage({ orgId, orgSlug }: UpgradePageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-8 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-bold mb-2">Your trial has ended</h1>
        <p className="text-muted-foreground">
          Subscribe to keep your data and continue building your DHF in ReqTrack.
        </p>
      </div>

      <div className="bg-card border rounded-xl p-8 w-full max-w-sm shadow-sm">
        <div className="flex items-baseline gap-1 mb-1">
          <span className="text-4xl font-bold">$29</span>
          <span className="text-muted-foreground">/month</span>
        </div>
        <p className="text-sm text-muted-foreground mb-6">
          ReqTrack Pro — everything included
        </p>

        <ul className="flex flex-col gap-3 mb-8">
          {FEATURES.map((f) => (
            <li key={f} className="flex items-center gap-2 text-sm">
              <CheckCircle2 className="h-4 w-4 text-green-500 shrink-0" />
              {f}
            </li>
          ))}
        </ul>

        <Button className="w-full" size="lg" onClick={() => openCheckout(orgId, orgSlug)}>
          Start subscription
        </Button>

        <p className="text-xs text-center text-muted-foreground mt-4">
          Questions?{' '}
          <a
            href="mailto:contact@ryanfreiden.com"
            className="underline underline-offset-2 hover:text-foreground"
          >
            Get in touch
          </a>
        </p>
      </div>
    </div>
  )
}
